import React from "react";

export default function ImageWithTextBlock({ data }) {
  return (
    <div
      style={{
        display: "flex",
        gap: "20px",
        background: "#111",
        padding: "20px",
        borderRadius: "12px",
        marginTop: "20px",
        color: "white",
      }}
    >
      <img
        src={data.image || "https://via.placeholder.com/400"}
        alt=""
        style={{ width: "45%", borderRadius: "12px" }}
      />

      <div>
        <h2>{data.title || "Image With Text"}</h2>

        <div
          dangerouslySetInnerHTML={{
            __html: data.content || "<p>Description text here...</p>",
          }}
        />
      </div>
    </div>
  );
}
